// removed by extract-text-webpack-plugin
module.exports = {"tackImg":"_3XwLqe1bH9Y7UStstLYNiJ","leftBar":"_18ki0MTP6yEB22arPgcvvC","personalInfo":"_1Jstn-MdkMPFT0HVpZ4DBC","red":"_3F6XFSiWcGcV4nTJbb08lt","menu":"_1SSV7Q_wkVLC-J8_Bav1wd","ic1":"_2iNeNJahIjbgFaTkr7tYry","ic2":"_1ZOevq6Uf0SHX79wQaH8nd","ic3":"_32RaLnLvq4IsJ10F5IqtbP","ic4":"_2-gHgruFeAa7-SciDkItaJ","ic5":"_2gez459fKb-Wg8Jv-xLsEo","back1":"_1zD887FqtAWJZBOIXeBFYz","back2":"Uqqno0IItx_E0F5MPPhzt","back3":"_1ec5HrS1EgSSt_WVN5_qff","back4":"_1ArT_tZBd8E9nc-kCscZn_","back5":"h32-YJCNtkKatC7nknVpd","active":"_2OpIhK-lYYny5-lfdp_-b8","rightContent":"_3h7ah8cuSWtsGP2Ikx_76s"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ContactUs/ContactUs.scss
 ** module id = 1056
 ** module chunks = 0
 **/